import React from 'react';
import Page from '../layout/Page';
import GetState from '../GetState';
import { QuestRoute } from '../api/QuestRoutes';
import Col from '../layout/Col';
import Heading from '../forms/Heading';
import { generateId, randomIntBetween, shortHandDate } from '../utility/functions';
import styled from 'styled-components';
import Button from '../forms/Button';
import ModalFactory from '../Modal';
import PageBreak from '../layout/PageBreak';
import Title from '../forms/Title';
import { EmbedVideo } from '../HelpDesk';
import Row from '../layout/Row';

const Indent = styled(Col)`
    gap: 0em;
    padding-left: 0.5em;
`

export const NewUpdateLanding = () => (
    <Col>
        <Title>Welcome to the updated Hamilton Hosted Solutions!</Title>
        <span>We've introduced exciting new tools and enhanced capabilities. As you explore the updated platform, we encourage you to use our feedback tool to ask questions, submit feature requests, or report any issues. As always, our Hosted Solutions Support team is here to help and support you as we navigate this update together.</span>
        <Row justify='center'><EmbedVideo src='https://www.youtube.com/watch?v=V5bfTxbMNNQ' /></Row>
    </Col>
)

const Updates = ({ ...props }) => {

    const [updates] = GetState(QuestRoute.updates, {
        loading: [],
        finalCall: (res) => res.map(item => ({
            title: `${item.release}: ${shortHandDate(item.releaseDate)}`,
            updates: item.updates.reduce((acc, update) => {
                acc[update.category] = (acc[update.category] || []).concat(update.description);
                return acc;
            }, {})
        }))
    });

    const testPromise = () => new Promise(res => setTimeout(() => res(1), randomIntBetween(1000, 2000)))
    const testError = () => new Promise((res, rej) => rej({ error: { errorMessage: 'An Error' } }))

    const test = async () => {

        ModalFactory.show({
            id: 'aBlank',
            title: 'a blank',
            passthrough: true
        })

        ModalFactory.confirmation({
            id: 'conf,',
            title: 'Conf Modal Test',
            body: 'Testing modal Conf.',
        })
            .then(() => {
                ModalFactory.close('conf,', 'aBlank')
            })

        ModalFactory.show({
            title: 'an acceptor test',
            slideToClose: true,
        })

        ModalFactory.confirmAndProcess({
            confirmation: {
                title: 'a test',
                body: 'to confirm'
            },
            promise: {
                title: 'a promise',
                body: 'doing a promise',
                callback: testPromise
            },
            confirmed: {
                title: 'a Success',
                body: 'we did it'
            },
        })

        ModalFactory.promise({
            id: 'testingError',
            title: 'Promise Modal Test',
            body: 'Testing modal promise.',
            callback: () => testError()
        })
            .then(() => {
                ModalFactory.update(({
                    id: 'testingError',
                    title: 'Success',
                    body: <div>REEEEEEEEEEEE</div>,
                }))
            })

        ModalFactory.promise({
            id: 'testingTimeout',
            title: 'Promise Modal Test',
            body: 'Testing modal promise.',
        })
            .then(() => {
                ModalFactory.update(({
                    id: 'testingTimeout',
                    title: 'Success',
                    body: <div>REEEEEEEEEEEE</div>,
                }))
            })

        ModalFactory.confirmation({
            id: 'conf',
            title: 'Conf Modal Test',
            body: 'Testing modal Conf.',
        })
            .then((res) => {
                if (res) {
                    ModalFactory.update(({
                        id: 'conf',
                        type: 'success',
                        title: 'Success',
                        body: <div>Clicked Yes</div>,
                    }))
                } else {
                    ModalFactory.update(({
                        id: 'conf',
                        type: 'error',
                        title: 'Rejected',
                        body: <div>Clicked No</div>,
                    }))
                }
            })
    }

    return (
        <PageBreak>
            {/* <NewUpdateLanding /> */}
            {updates.map((e, i) => (
                <Col key={`update-${i}`}>
                    <Heading>{e.title}</Heading>
                    {Object.entries(e.updates).map(([key, value]) => (
                        <Indent key={generateId()}>
                            <b>{key}</b>
                            <Indent>
                                {value.map(f => <span key={generateId()}>- {f}</span>)}
                            </Indent>
                        </Indent>
                    ))}
                </Col>
            ))}
        </PageBreak>
    );
}

export default Updates;
